import React from "react";
import Container from "react-bootstrap/Container";
import useGoTo from "../../hooks/useGoTo";
import { STATUS_DETAILS } from "../../ducks/consts";
import Loading from "../../components/Loading";
import TotemResult from "./TotemResult";

export default function SelfCheckoutTotemStatus({
  shortReference,
  order,
  cache,
  status,
}) {
  const goto = useGoTo();
  const [seconds, setSeconds] = React.useState(30);
  const jaVoltou = React.useRef(false);
  // imprime uma vez só, mesmo que o polling do status re-renderize a tela
  const jaImprimiu = React.useRef(false);

  const paid = status
    ? status.some((s) => s.code === STATUS_DETAILS.CONFIRMED.code)
    : false;

  const cancelled = status
    ? status.some((s) => s.code === STATUS_DETAILS.CANCELLED.code)
    : false;

  React.useEffect(() => {
    if (paid || cancelled) {
      const id = setInterval(() => setSeconds((v) => v - 1), 1000);
      return () => clearInterval(id);
    }
  }, [paid, cancelled]);

  React.useEffect(() => {
    if (paid && !jaImprimiu.current && cache && cache.orderId) {
      console.log(`native interface print ${cache.orderId}`);
      if (window.posNativeInterface) {
        window.posNativeInterface.printAppPedido(cache.orderId);
      } else {
        console.log(`native interface not found!!`);
      }
      jaImprimiu.current = true;
    }
  }, [paid, cache]);

  // Antes isto rodava no corpo do render (`if (seconds <= 0) handleNovoPedido()`),
  // ou seja, um history.replace durante a renderização — e repetindo a cada
  // tick depois do zero. O ref garante que dispare uma vez só.
  React.useEffect(() => {
    if (seconds > 0 || jaVoltou.current) return;
    jaVoltou.current = true;
    goto("/");
  }, [seconds, goto]);

  if (!order || !status) {
    return (
      <Container>
        <Loading message="Carregando Status Autoatendimento Totem..." />
      </Container>
    );
  }

  const handleNovoPedido = () => {
    goto("/");
  };

  const newOrderButton = (
    <button
      type="button"
      className="btn btn-shop totem-btn totem-btn--primary"
      onClick={handleNovoPedido}
    >
      Novo pedido ({seconds})
    </button>
  );

  if (cancelled) {
    return (
      <TotemResult
        tone="danger"
        title="O pagamento foi cancelado"
        orderNumber={shortReference}
        actions={newOrderButton}
      />
    );
  }

  if (paid) {
    return (
      <TotemResult
        tone="success"
        title="Pagamento aprovado!"
        message="Vamos preparar o seu pedido e chamar pelo número quando estiver pronto."
        orderNumber={shortReference}
        actions={newOrderButton}
      />
    );
  }

  return (
    <TotemResult
      tone="pending"
      title="Pague na maquininha"
      message="Siga as instruções na maquininha ao lado."
      orderNumber={shortReference}
    />
  );
}
